import React from 'react';
import PropTypes from 'prop-types';

import { ListItemText as MuiListItemText } from '@material-ui/core';

const ListItemText = ({ children, ...rest }) => {
  return (
    <MuiListItemText
      {...rest}
    >
      { children }
    </MuiListItemText>
  )
}

ListItemText.defaultProps = {
  children: null,
}

ListItemText.propTypes = {
  children: PropTypes.node,
}

export default ListItemText;



// WEBPACK FOOTER //
// ./src/components/base/ListItemText/ListItemText.js